module.exports = __webpack_public_path__ + "static/2b5934ca0a7cfee41987ebe80778abb08dd9432da0dc3770ac18a70ab60194ac-d80206a2eb5a58f848398c082198dc3d.jpeg";